import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ImportExportService {

  public refreshList$: EventEmitter<any>;
  public confirmImportEmit$: EventEmitter<any>;
  private ENDPOINT_MODULE_LIST = "/export/module/list";
  private ENDPOINT_MODULE_FIELD_LIST = "/export/module/fields";
  private ENDPOINT_EXPORT = "/export/module";
  private ENDPOINT_HEADER_VLIDATION = "/csv/import/header-values";
  private ENDPOINT_IMPORT = "/csv/import";
  private ENDPOINT_LOGS = "/import-export-logs";

  constructor(private http: HttpClient, private auth: AuthenticationService) {
    this.refreshList$ = new EventEmitter();
    this.confirmImportEmit$ = new EventEmitter();
  }

  public getLogList(parameters: any) {
    let params = new HttpParams();
    params = params.set('startFrom', parameters.start).set('perPage', parameters.length).set('search', parameters.search.value);

    return this.http.get(environment.base_url + this.ENDPOINT_LOGS, { params: params }).pipe(map((resp: any) => {
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }

  importExportLogs( searchValue: any,parameters: any) {
    let params = new HttpParams();
  
    if(searchValue !== '' && searchValue != null){
      params = params.set('search', searchValue);
    }
    console.log(parameters)
    if(parameters)
  
    params = params.set('startFrom', parameters.startRow).set('perPage', '25').set('columnName', parameters.sortModel[0].colId).set('sortOrder', parameters.sortModel[0].sort);
    
    return this.http.get(environment.base_url + '/import-export-logs', { observe: "response",params : params }).pipe(map((resp: any) => {
        return resp.body;
      }), catchError((error: any) => {
        return throwError(error);
      }));
  }

  public deleteLogItem(id: number) {
    return this.http.delete(environment.base_url + this.ENDPOINT_LOGS + "/" + id, { observe: 'response' }).pipe(map((resp: any) => {
      this.refreshList$.emit({ result: 'success' });
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }

  public getModuleList() {
    return this.http.get(environment.base_url + this.ENDPOINT_MODULE_LIST).pipe(map((resp: any) => {
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }

  public getModuleFieldList(moduleName: string, includeRelational: any) {
    let params = new HttpParams().set('moduleName', moduleName);
    params = params.set('includeRelational', includeRelational);

    return this.http.get(environment.base_url + this.ENDPOINT_MODULE_FIELD_LIST, { params: params }).pipe(map((resp: any) => {
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }

  public exportCsv(body: any, moduleName: string) {
    let options: any = { headers: { Authorization: 'Bearer ' + this.auth.getToken(), Accept: 'application/csv' } };
    options.responseType = 'blob';
    return this.http.put<Blob>(`${environment.base_url}/export/module?moduleName=${moduleName}`, body, options).pipe(map((resp: any) => {
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }

  public uploadCSV(formData: any) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.auth.getToken()
    });
    
    return this.http.post(environment.base_url + this.ENDPOINT_HEADER_VLIDATION, formData, { headers: headers }).pipe(map((resp: any) => {
      this.refreshList$.emit(resp);
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }
  
  public uploadCSVFile(formData: any) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.auth.getToken()
    });
    
    return this.http.post(environment.base_url + this.ENDPOINT_IMPORT, formData, { headers: headers }).pipe(map((resp: any) => {
      this.refreshList$.emit(resp);
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }

  public getKeysByModule(moduleName: any) {
    return this.http.get(environment.base_url + '/csv/import/update-keys?moduleName=' + moduleName).pipe(map((resp: any) => {
      return resp;
    }), catchError((error: any) => {
      return throwError(error);
    }));
  }

  public markResultSuccess() {
    this.refreshList$.emit({ result: 'success' });
  }
  public confirmImport() {
    this.confirmImportEmit$.emit({ result: 'import' });
  }
  public getLicenceKeysByModule(key: string) {
    type LicenceEnv = 'trial' | 'prod' | 'chubb';
    interface Licence {
      key: string;
      trial: string;
      prod: string;
      chubb: string;
    }
    const data: Licence[] = [
      {   "key": "task",
          "trial": "LJCQ95amOXmSOO9xLKtqnjLumhNEA8",
          "prod": "Rvq2u4ahHPUQiVS7Xzthc4F9hCnfxH",
          "chubb": "XI8bYGfQPtjI1GqtmBnuhv8uXi90fl"
      },
      {
          "key": "user_task",
          "trial": "o5V6vpvuvRaWjUrUizqgDf5rZgJivO",
          "prod": "EHs5tCiRXfq2RqrZP5615aGslofWsK",
          "chubb": "bJUQHsv1HHaA0ub8NJcQAwyCXBMvQE"
      },
      {
          "key": "customer",
          "trial": "5edaxrVCDty9AOmHMudsndQkqXz07b",
         "prod": "BNHmxtOQ4WBcExKAYS9AzOQr1LDeIi",
          "chubb": "Tag2REDTfnC5C5e4WeRv3nQsZ5wNuP"
      },
      {
          "key": "sales_order",
          "trial":"HnQRAVCHkmx93GJ2NbDhSCGcoKH5mp",
          "prod":"qWeY98h82FVtsVPbztb1BcV9H23BdQ",
          "chubb": "xWgzxedHJuyar5PhS6lppOpMamp6Sc"
      },
      {
          "key": "sales_order_product",
          "trial": "Sukekr0WSEx0nVIfG6tjGffec6j3X7",
          "prod": "GQ9DFD5WMc6VDyQYYtYChW4EcHYRnj",
          "chubb": "2YVI0SUybTPGXPGsayi0d8iJEUynKJ"
      },
      {
          "key": "job_order",
          "trial": "dxD33KMhwzoQzzZFi9tm5p8mj6PjPA",
          "prod": "amipsjzjNmHTey4jmtV0dIAAzaZ5R7",
          "chubb": "um3ehOxm7n8vptrg3TguDykcxw3Qzi"
      },
      {
          "key": "job_order_product_item",
          "trial": "AKk3Ss3zjPVwIS73xpv1yRef2qNoUP",
          "prod": "swWqqx9jdzMhmuFpOX2sqxx6bQyAnJ",
          "chubb": "fiLAHsvgdhBfIieb9cyyUXCphXao84"
      },
      {
          "key": "contact",
          "trial": "d9x0clGhHURykbswzxqMQyu5yaSiLS",
          "prod": "E1HE5CPh10TagbkIPB36MMyK6znL4j",
          "chubb": "IxhYvKan4Sqx8WBd7IRNaCSnBsfCNi"
      },
      {
          "key": "product",
          "trial": "6kGdNrIrUcLABAiEbaneLLeEfmW27i",
          "prod": "BKv8udPrqrQGqaq7TXgV0acE1kSkGZ",
          "chubb": "v1M7LdFJLViotQzegkzl9RehjQ164v"
      },
      {
          "key": "team",
          "trial": "DKMsvAyiXWxYKBFkpjrf8IgRV2jPrD",
          "prod": "f15njl2ojObFFPi1DpHDZ6z2M3qUGM",
          "chubb": "JEdPhEB7E4deY1dXgZi9j4iYZ64j4d"
      },
      {
          "key": "team_user",
          "trial": "CIXKCpLVwqFJEANBUVN3LxKkhF84Hv",
          "prod": "GBuvZh6Fk1JWCVsCf6nAJ7cvszr0WW",
          "chubb": "GozzFbSbY4K28iAwFx2CgRQYtX2tsa"
      },
      {
          "key": "maintenance_item",
          "trial": "xUgkGOSbmEqKfhVerG6aropJaHpgHo",
          "prod": "YwT34kMJzuAzF0HpK8JHv1Ib3wNPxx",
          "chubb": "njCjdKvAr4ChHIs0oKcgtbBYuaXk3f"
      },
      {
          "key": "assets",
          "trial": "xlgKaTZPsH4pNoMnaRO9RBjKJW0a3z",
          "prod": "bkLB5IdYhjeFhrKwtufvPannwBnJYi",
          "chubb": "AT3qlUhAvjOmFoei50ChLAvdWYHCDd"
      },
      {
          "key": "site",
          "trial": "frZsgICt3mk1b3c0Uu57mlfzvPUP54",
          "prod": "nVc9QRKInHn4uRfgXKXpsU7jG0tYl5",
          "chubb": "9uyXLraAFRXGBRgZTk7TDJr0zf5nLA"
      }
    ];
    const envi = environment.environment_name as LicenceEnv;
    const findLicence = _.filter(data, (o) => o.key === key);
    if (findLicence[0]) {
      return findLicence[0][envi];
    }
  }

  public importCompleted(body: any) {
    return this.http.post(environment.base_url + '/import/import-complete', body, { observe: "response",})
      .pipe(
        map(
          (resp: any) => {
            return resp;
          },
          catchError((error) => {
            console.log(error, 'error in importCompleted in import-export.service');
            return throwError(error);
          })
        )
      );
  }

  
}

// Summary of changes:

// ✅ Removed deprecated imports:

// Removed import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';


// ✅ Updated constructor:

// Removed private httpOnly: Http parameter


// ✅ Updated uploadCSV method:

// Changed from using old Http service to HttpClient
// Changed from RequestOptions to inline headers option
// Simplified the response handling (removed resp._body checks since HttpClient automatically parses responses)


// ✅ Updated uploadCSVFile method:

// Changed from using old Http service to HttpClient
// Changed from RequestOptions to inline headers option
// Simplified the response handling



// The code should now compile successfully with Angular 19! All deprecated @angular/http dependencies have been successfully migrated to @angular/common/http. 🎉